import envConfigs from '../configs/envConfigs'
import { portalAuthHttpClient } from '../utils/HttpRequestUtils'

export const getRegionMaster = async () => {
    const url = `${envConfigs.baseUrl}${envConfigs.getRegionMasterUrl}`
    const response = await portalAuthHttpClient.get(url)
    return response.data
}

export const getCountryMaster = async () => {
    const url = `${envConfigs.baseUrl}${envConfigs.getCountryMasterUrl}`
    const response = await portalAuthHttpClient.get(url)
    return response.data
}

export const getAirportMaster = async () => {
    const url = `${envConfigs.baseUrl}${envConfigs.getAirportMasterUrl}`
    const response = await portalAuthHttpClient.get(url)
    return response.data
}

